import React from "react";
import { Spinner } from "react-bootstrap";

export const ButtonLoadingSpinner = () => {
  return (
    <>
      <div>
        <Spinner
          as="span"
          animation="grow"
          size="sm"
          role="status"
          aria-hidden="true"
        />{" "}
        <span style={{ marginLeft: "5px" }}>Loading...</span>
      </div>
    </>
  );
};
